import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class Marijuana extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Marijuana" />
                <div className="container" style={{marginTop:"60px"}}>
                    <HashLink to='/faq#marijuana'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationCannabis.png" alt="marijuana">
                        </img>
                        
                        </div>
                    </div>
                    <div className="content">
                        
                        <h2>Marijuana</h2>
                        <p>Cannabis is a general term used for a variety of drugs <b>made from the plant Cannabis sativa</b>. The major psychoactive constituent in cannabis is <b>THC</b>. The term <b>'marijuana'</b> refers to cannabis leaves or other crude plant material. The unpollinated female plants are called <b>hashish</b>. Cannabis oil (hashish oil) is a concentrate of cannabinoids obtained by solvent extraction of the crude plant material or of the resin.</p>
                        <hr />
                        <p>
                            Common street names are marijuana, blunt, dope, ganja, joint, Mary Jane, pot, smoke, weed and hashish.
                        </p>
                        <hr />
                        <p>
                            Cannabis is used for its mental and physical effects <b>("high" or "stoned")</b>, a general <b>change in perception, euphoria</b> (heightened mood), and an <b>increase in appetite</b>. Onset of effects is within minutes when smoked, and about 30 to 60 minutes, when cooked and eaten they last for between two and six hours.
                        </p>
                        <p>
                        Marijuana is related to a stronger drug, hashish, which is derived from the resin exuded by the cannabis plant and made into a gummy powder. Hashish, like marijuana, is usually smoked. Although marijuana can be considered a mild hallucinogen, there are significant differences between the nature, intensity, and duration of its effects and those induced by drugs like LSD.
                        </p>
                        <h5>Short-term side effects :- </h5>
                        <ul>

                            <li><p>Decrease in short-term memory</p></li>
                            <li><p>Dry mouth</p></li>
                            <li><p>Impaired motor skills</p></li>
                            <li><p>Red eyes</p></li>
                            <li><p>Feelings of paranoia or anxiety</p></li>

                        </ul>
                        <h5>Long-term side effects :-</h5>
                        <ul>
                            <li>
                                <p>
                                Infections in throat, lungs
                                </p>
                                
                            </li>
                            <li>
                                <p>
                                Decreased mental ability in those who started as teenagers
                                </p>
                            </li>
                            <li>
                                <p>
                                Cannabis used during pregnancy is associated with impairment in fetal development leading to a reduction in birth weight
                                </p>
                            </li>
                            <li>
                                <p>
                                Behavioural problems in children whose mothers used cannabis during pregnancy
                                </p>
                            </li>
                            <li>
                                <p>
                                Higher risk of bronchitis
                                </p>
                            </li>

                        </ul>
                        <h5>Forms in which it is consumed </h5>
                        <ul>
                            <li><p>
                                Smoking</p>
                            </li>
                            <li><p>
                                Small pipes</p>
                            </li>
                            <li><p>
                                Bongs</p>
                            </li>
                            <li><p>
                                Paper-wrapped joints</p>
                            </li>
                            <li><p>
                                Tobacco-leaf-wrapped blunts</p>
                            </li>
                            <li><p>
                                Vaporizer</p>
                            </li>
                            <li><p>
                                Cannabis Tea</p>
                            </li>
                            <li><p>
                                Edibles</p>
                            </li>

                        </ul>

                    </div>
                </div>
            </div>
        )
    }
}

export default Marijuana;